import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
// import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
// import VueMask from 'v-mask'
// import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import './registerServiceWorker'
import { register } from 'register-service-worker';

// import flatPickr from 'vue-flatpickr-component'

Vue.use(VueFeather)
// Vue.use(flatPickr)

Vue.use(VueRouter)
// Vue.use(vco)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
// Vue.use(VueMask)

Vue.prototype.$administrative = 'administrative';
Vue.prototype.$prejudicial = 'prejudicial'


if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}

// Vue.component('apexchart', VueApexCharts)

// Use real api if environment variable is set
if (process.env.VUE_APP_FRONTEND_BASE_URL) {
  Vue.prototype.$http = require('axios')
  Vue.prototype.$http.defaults.baseURL  = process.env.VUE_APP_FRONTEND_BASE_URL
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
